/*
 * @Author: your name
 * @Date: 2020-08-19 16:28:05
 * @LastEditTime: 2020-09-07 18:40:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/config.js
 */
import Vue from 'vue'
const $t = Vue.prototype.$t

export const accumulationFundEnum = [
  { text: $t('1475'), value: '1' }, // 正常缴存
  { text: $t('1476'), value: '2' } // 无需缴存
]

export const socialSatausConfig = [
  {
    text: $t('940'),
    value: '1'
  },
  {
    text: $t('941'),
    value: '2'
  }
]
export const taxDeductionConfig = [
  {
    text: $t('basic_info_1'), // 个人所得税
    value: '3'
  },
  {
    text: $t('basic_info_2'), // 预扣税
    value: '4'
  },
  {
    text: $t('942'), // 不扣税
    value: '2'
  }
  // { text: $t('basic_info_1'), value: '1' }
]
export const bankConfig = [
  {
    text: 'BBL',
    value: 'BBL',
    minLength: 10
  },
  {
    text: 'KTB',
    value: 'KTB',
    minLength: 10
  },
  {
    text: 'SCB',
    value: 'SCB',
    minLength: 10
  },
  {
    text: 'TTB',
    value: 'TTB',
    minLength: 10
  },
  {
    text: 'GSB',
    value: 'GSB',
    minLength: 12,
    maxLength: 15
  },
  {
    text: 'KBANK',
    value: 'KBANK',
    minLength: 10
  },
  {
    text: 'SC',
    value: 'SC',
    minLength: 10
  },
  {
    text: 'ICBC',
    value: 'ICBC',
    minLength: 10
  },
  {
    text: 'KKP',
    value: 'KKP',
    minLength: 14
  },
  {
    text: 'TISCO',
    value: 'TISCO',
    minLength: 14
  },
  {
    text: 'CIMB',
    value: 'CIMB',
    minLength: 10
  },
  {
    text: 'BAY',
    value: 'BAY',
    minLength: 10
  },
  {
    text: 'UOB',
    value: 'UOB',
    minLength: 10
  }
]
